<section class="l-reset">
  <div class="reset">
    <div class="reset-body" *ngIf="verified && isRequestFinished">
      <div class="reset-cover">
        <img src="/assets/images/no-email.png" alt="" class="image" />
      </div>
      <div class="reset-title">
        {{ "Email verified" | translate }}
      </div>
      <p class="reset-desc">
        {{ "you will be redirect" | translate : { counter: this.counter } }}
      </p>
    </div>

    <ng-container *ngIf="!verified && isRequestFinished">
      <div class="reset-body">
        <div class="reset-cover">
          <img
            src="/assets/images/login/header-type-user.png"
            alt=""
            class="image"
          />
        </div>
        <div class="reset-title">
          {{ errorMsg || "error occured" | translate }}
        </div>
        <button routerLink="/" type="button" class="btn btn-primary w-100 mb-3">
          {{ "Go back" | translate }}
        </button>
      </div>
    </ng-container>
  </div>
</section>
